import { createSlice } from "@reduxjs/toolkit";
import { datetimeToDateNoUTC, today, yesterday } from "utils/time";

const defaultDateRange = () => [
  datetimeToDateNoUTC(yesterday()).toString(),
  datetimeToDateNoUTC(today()).toString(),
];

const simulatorSlice = createSlice({
  name: "simulator",
  initialState: {
    useDsoMeasurements: false,
    opportunityCostsDateRange: defaultDateRange(),
    openSessionsDateRange: defaultDateRange(),
    deleteSessionsDateRange: defaultDateRange(),
  },
  reducers: {
    setUseDsoMeasurements: (state, action) => {
      state.useDsoMeasurements = action.payload;
    },
    setOpportunityCostsDateRange: (state, action) => {
      state.opportunityCostsDateRange = action.payload;
    },
    setOpenSessionsDateRange: (state, action) => {
      state.openSessionsDateRange = action.payload;
    },
    setDeleteSessionsDateRange: (state, action) => {
      state.deleteSessionsDateRange = action.payload;
    },
  },
});

export const {
  setUseDsoMeasurements,
  setOpportunityCostsDateRange,
  setOpenSessionsDateRange,
  setDeleteSessionsDateRange,
} = simulatorSlice.actions;

export default simulatorSlice.reducer;
export const selectUseDsoMeasurements = (state) => state.simulator.useDsoMeasurements;
export const selectOpportunityCostsDateRange = (state) =>
  state.simulator.opportunityCostsDateRange ?? defaultDateRange();
export const selectOpenSessionsDateRange = (state) =>
  state.simulator.openSessionsDateRange ?? defaultDateRange();
export const selectDeleteSessionsDateRange = (state) =>
  state.simulator.deleteSessionsDateRange ?? defaultDateRange();
